import { render } from "./PaymentCallback.vue?vue&type=template&id=0bcd25a7&scoped=true"
import script from "./PaymentCallback.vue?vue&type=script&lang=js"
export * from "./PaymentCallback.vue?vue&type=script&lang=js"

import "./PaymentCallback.vue?vue&type=style&index=0&id=0bcd25a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcd25a7"]])

export default __exports__